import Color from 'color';

import { CheckCreator } from 'lib/utils/formValidation/formValidation';
import isEmpty from 'lib/utils/formValidation/isEmpty';

// Minimum contrast taken from WCAG guidelines.
// https://www.w3.org/WAI/WCAG21/quickref/?versions=2.0#contrast-minimum
const MINIMUM_CONTRAST = 4.5;

// Check against array of colors. Fails if contrast is too low with any.
const isColorContrastHighEnough: CheckCreator<string> =
  (firstColor: string | string[]) => (secondColor: string) => {
    const compare = (first: string, second: string) =>
      isEmpty(first) ||
      isEmpty(second) ||
      Color(firstColor).contrast(Color(secondColor)) > MINIMUM_CONTRAST;
    if (Array.isArray(firstColor)) {
      return firstColor.every((firstColor) => compare(firstColor, secondColor));
    } else {
      return compare(firstColor, secondColor);
    }
  };

export default isColorContrastHighEnough;
